<template>
  <div id="dictionaryInprogress">
    <div class="row">
      <div class="col-12 col-sm-6 col-md-7">
        <div class="breadcrumbs">
          <p :lang=selectedLanguageCode>{{ $t('message.you-are-here') }}</p>
          <ul>
            <li>
              <router-link tag="a" to="/">{{ $t('message.LEXIN') }}</router-link>
            </li>
            <li>
              <font-awesome-icon icon="arrow-right" class="right-agap"/>
              <router-link tag="a" :to="{ name: 'AboutComponent'}">{{ $t('message.about') }}</router-link>
            </li>
            <li>
              <font-awesome-icon icon="arrow-right" class="right-agap"/>
              <span>{{ $t('message.new-dictionaries') }}</span>
            </li>
          </ul>
        </div>
      </div>
      <Language></Language>
    </div>
    <div class="row">
      <div class="col-12">
        <h1>
          <span>{{ $t('message.new-dictionaries') }}</span>
        </h1>
        <div class="clearfix"></div>
        <div class="home-info">
          <h2 class="title">
            {{ $t('message.printed-editions') }}
          </h2>
          <ol style="list-style-type: disc;">
            <li>{{ $t('message.norwegian-dari-planned') }}</li>
          </ol>
          <p>{{ $t('message.more-editions-are-planned') }}</p>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Language from "./Language.vue";
export default {
  name: "DictionaryInprogressComponent",
  data() {
    return {
       languageCodeList:[
        {lang:'eng',langISOCode:'en'},
        {lang:'nny',langISOCode:'nn'},
        {lang:'nbo',langISOCode:'nb'}
      ]
    }
  },
  computed: {
    selectedLanguageCode () {
      return this.languageCodeList.find(x=>x.lang==localStorage.getItem('lang')).langISOCode;
    },
  },
  components: {
    Language
  },
  created() {
    $("body,html").animate(
      {
        scrollTop: 0
      },
      60
    );
  }
};
</script>

